const codeMessage = {
    200: "服务器成功返回请求的数据",
    201: "新建或修改数据成功。",
    202: "一个请求已经进入后台排队（异步任务）",
    204: "删除数据成功。",
    302: "重定向",
    400: "发出的请求有错误，服务器没有进行新建或修改数据,的操作。",
    401: "用户没有权限（令牌、用户名、密码错误）。",
    403: "用户得到授权，但是访问是被禁止的。",
    404: "发出的请求针对的是不存在的记录，服务器没有进行操作",
    406: "请求的格式不可得。",
    410: "请求的资源被永久删除，且不会再得到的。",
    422: "当创建一个对象时，发生一个验证错误。",
    500: "服务器发生错误，请检查服务器",
    502: "网关错误",
    503: "服务不可用，服务器暂时过载或维护",
    504: "网关超时",
}

function AuthorityError(message) {
    this.message = message || "当前用户未登录!"
    this.name = "AuthorityError"
}

AuthorityError.prototype = new Error()
AuthorityError.prototype.constructor = AuthorityError

// 处理AJAX请求结果
// function checkStatus(response) {
//     if (response.status >= 200 && response.status < 300) {
//         return response
//     } else if (response.status === 401) {
//         throw new AuthorityError("请先登录再进行操作!")
//     }
//     const errorText = codeMessage[response.status] || response.statusText
//     console.error({
//         message: `请求错误 ${response.status}:${response.url}`,
//         description: errorText,
//     })
//     throw new Error(errorText)
// }

export default function request(url, options, callback) {
    const newOptions = {...options}
    if (newOptions.method === "POST" || newOptions.method === "PUT") {
        newOptions.headers = {
            Accept: "application/json",
            ContentType: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "PUT,POST,GET,DELETE,OPTIONS",
            // ...newOptions.headers,
        }
    }
    fetch &&
        fetch(url, newOptions)
            // .then((response) => checkStatus(response, url))
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                if (callback) {
                    callback(data)
                }
            })
}
